const { regexes } = require('@transfeeradev/api-enums');

const mostBanksDigitSchema = {
  agency: {
    digit: {
      pattern: regexes.bankAccount.NUMERIC_DIGIT
    }
  },
  account: {
    digit: {
      pattern: regexes.bankAccount.NUMERIC_DIGIT
    }
  }
};

module.exports = mostBanksDigitSchema;
